import { DatePipe } from "@angular/common";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Constants } from "../../_model/constants";
import { FilterDto } from "../../_model/filterDto";
import { MultipleFilterProperty } from "../../_model/multiple-filter-property";
import { ReportFilterDto } from "../../_model/ReportFilterDto";
import { ReprocessWoDTO } from "../../_model/ReprocessWorkOrderDTO";
import { ReprocessFilterDto } from "../../_model/ReprocessFilterDto";
// import { reprocessClass } from "src/app/_model/Reprocess/reprocessClass";
// import { reprocessResponse } from "src/app/_model/Reprocess/reprocessResponse";
import { TableResponse } from "../../_model/table-response/table-response";
import { UserService } from "../user.service";
import { PageParams } from "./page-params";

@Injectable({
  providedIn: "root",
})
export abstract class ReprocessingTableService {
  baseUrl!: string;
  multilpleFilterBaseUrl!: string;

  reprocessingUrl!: string;
  isReportRoute = false;
  filterDto!: ReprocessFilterDto;
  fmSystem: any;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private router: Router,
    public datepipe: DatePipe
  ) {}

  getTableData(filters: FormGroup | null, page: number, size: number): Observable<TableResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    let url = this.userService.getClientBaseNewUrl() + this.multilpleFilterBaseUrl;

    if (
      filters?.value?.multipleFilterarray?.length > 0
    ) {
      this.createBody(filters!);
      let body = this.filterDto;
      //this.filterDto = new ReportFilterDto;
      return this.http.post<TableResponse>(url, body, { params: pageParams });
    }
    
    if (filters?.value?.tableFilter?.column === "workOrderNumber") {
      let currentDate = new Date();
      let todaysDate = this.datepipe.transform(
        currentDate,
        Constants.backendDateFormat
      );
      currentDate.setDate(currentDate.getDate() - 30);
      currentDate.setMinutes(0);
      currentDate.setHours(0);
      let startDate = this.datepipe.transform(
        currentDate,
        Constants.backendDateFormat
      );
      let body = {
        dateName: "dateReceived",
        date: startDate + " = " + todaysDate,
        status: null,
        "woList": filters?.value?.value
      };
      return this.http.post<TableResponse>(url, body, { params: pageParams });
    }

    // Default / Fallback (No filters or empty filters)
    let currentDate = new Date();
    let todaysDate = this.datepipe.transform(
      currentDate,
      Constants.backendDateFormat
    );
    currentDate.setDate(currentDate.getDate() - 30);
    currentDate.setMinutes(0);
    currentDate.setHours(0);
    let startDate = this.datepipe.transform(
      currentDate,
      Constants.backendDateFormat
    );
    let body = {
      dateName: "dateReceived",
      date: startDate + " = " + todaysDate,
      status: null,
      woList: null
    };
    return this.http.post<TableResponse>(url, body, { params: pageParams });
  }

  private createBody(filters: FormGroup) {
    let dto = new ReprocessFilterDto();
    let statusArr: Array<string> = [];
    filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty) => {
      if (element.column == Constants.dateConst) {
        if (element.dateBackendName == Constants.dateReceived) {
          dto.dateName = Constants.backendDateReceived;
        } else {
          dto.dateName = Constants.backendScheduledStartDate;
        }

        let start_date = this.datepipe.transform(
          element.origionalStartDateFormat,
          Constants.backendDateFormat
        );
        let end_date = this.datepipe.transform(
          element.origionalEndDateFormat,
          Constants.backendDateFormat
        );
        dto.date = start_date + " = " + end_date;
      } else {
        statusArr.push(element.value);
        dto.woList = '';
      }
    });
      statusArr.forEach(function (value) {
      dto.status.push(value);
    });
    this.filterDto = dto;
  }
  reprocess(
    selectedWorkOrders: any,
    loopCount: number,
    page: number,
    size: number
  ): Observable<ReprocessWoDTO> {
    let body = {
      reprocessWorkOrders: selectedWorkOrders,
      loopCount: loopCount,
    };
    let url = this.userService.getClientBaseNewUrl() + this.reprocessingUrl;

    const params = new HttpParams().set("page", page).set("size", size);
    return this.http.post<ReprocessWoDTO>(url, body, { params: params });
  }
}
